import { CalendarPrintPreviewBase } from './CalendarPrintPreview.base';
import type {
    CalendarPrintPreviewProps,
    CalendarPrintPreviewStyleProps,
    CalendarPrintPreviewStyles,
} from './CalendarPrintPreview.types';
import { styled } from '@fluentui/react/lib/Utilities';
import { getPalette } from 'owa-theme';
import { SurfaceConstants } from 'owa-calendar-surface-core';
export type { CalendarPrintPreviewProps };

/** The default style of CalendarPrintPreview */
export function getStyles(styleProps: CalendarPrintPreviewStyleProps): CalendarPrintPreviewStyles {
    let themeSymbols = getPalette();
    return {
        root: [
            'ms-CalendarPrintPreview',
            {
                display: 'flex',
                flexFlow: 'column',
                minWidth: SurfaceConstants.printPreviewMinPaneWidth,
            },
            styleProps.className,
        ],
        previewLabel: {},
        pivot: {
            flexGrow: 1,
            position: 'relative',
            maxWidth: '90%',
        },
        printPage: [
            {
                border: 'solid 1px',
                overflow: 'hidden',
                borderColor: styleProps.theme.palette.neutralTertiaryAlt,
                backgroundColor: themeSymbols.white,
                boxSizing: 'border-box',
                selectors: {
                    '#calendarPrintableItem &': {
                        position: 'absolute', // in print preview, the mulitple pages stack, but when printing they are one after another
                        transform: 'scale(' + styleProps.pageZoom + ')',
                        transformOrigin: styleProps.isRTL ? '100% 0' : '0 0',
                    },
                },
            },
            !styleProps.agenda && {
                transform: 'scale(' + styleProps.pageZoom + ')',
                transformOrigin: styleProps.isRTL ? '100% 0' : '0 0',
            },
        ],
        printWrapper: {
            /**
             * in Edge and IE, using transform property to shrink an element does not change it's initial size in the DOM layout,
             * so extra scroll bars get added or removed even though the item gets resized. To fix that, we need to set the parent container
             * to be the actual desired size.
             * https://stackoverflow.com/questions/21248111/overflow-behavior-after-using-css3-transform
             */
            position: 'relative',
            width: 888 * styleProps.pageZoom + 20, // 888 + padding
            height: 1130 * styleProps.pageZoom + 20, //1130 + padding
            overflow: 'hidden',
        },
        ffprintPage: {
            transform: 'scale(0.5)',
            transformOrigin: styleProps.isRTL ? '100% 1%' : '0 1%',
        },
    };
}

/** The default styled version of CalendarPrintPreview */
export const CalendarPrintPreview = styled<
    CalendarPrintPreviewProps<{}>,
    CalendarPrintPreviewStyleProps,
    CalendarPrintPreviewStyles
>(CalendarPrintPreviewBase, getStyles) as typeof CalendarPrintPreviewBase;
